// common.js
import axios from 'axios';
import { logoutUser } from './../utils/authUtils'; // update path
import qs from 'qs';
import { getDefaultStore } from 'jotai';
import { authAtom } from '../states/auth';

const store = getDefaultStore();


let getAuthToken = () => {
  const auth = store.get(authAtom);
  return auth?.token || null;
};

export const setAuthTokenGetter = (getterFn) => {
  console.log("setAuthTokenGetter", getterFn);
  getAuthToken = getterFn;
};

// List of public (unauthenticated) API paths
const publicEndpoints = [
  'auth/signin',
  'auth/forget-password',
  'auth/reset-password',
  'auth/verify-reset-password'
];

const isPublicEndpoint = (url) => {
  return publicEndpoints.some((publicPath) => url.includes(publicPath));
};

const defaultHeaders = () => {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

const apiClient2 = axios.create({
  baseURL: 'https://uatapi.assistlink.io/v2/',
});

apiClient2.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("401 Unauthorized - Logging out...");
      logoutUser();
    }
    return Promise.reject(error);
  }
);
const mergeHeaders = (customHeaders = {}) => {
  return { ...defaultHeaders(), ...customHeaders };
};

export const get = async (url, params = {}, headers = {}) => {
  const finalHeaders = mergeHeaders(headers);

  if (!finalHeaders.Authorization && !isPublicEndpoint(url)) {
    console.warn("GET Request blocked: Missing Authorization header.");
    return null;
  }

  try {
    console.log("GET Request →", { url, params, headers: finalHeaders });

    const response = await apiClient2.get(url, {
      headers: finalHeaders,
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    });
    return response.data;
  } catch (error) {
    console.error("GET Request Error:", error.response || error);
  }
};

export const post = async (url, data = {}, headers = {}, params = {}) => {
  const finalHeaders = mergeHeaders(headers);

  if (!finalHeaders.Authorization && !isPublicEndpoint(url)) {
    console.warn("POST Request blocked: Missing Authorization header.");
    return null;
  }

  try {
    const response = await apiClient2.post(url, data, {
      headers: finalHeaders,
      params,
    });
    return response.data;
  } catch (error) {
    console.error('POST Request Error:', error);
    throw error;
  }
};

export const patch = async (url, data = {}, headers = {}, params = {}) => {
  const isFormData = data instanceof FormData;

  const token = getAuthToken();
  const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

  const finalHeaders = {
    ...authHeader,
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    Accept: 'application/json',
    ...headers,
  };

  if (!finalHeaders.Authorization && !isPublicEndpoint(url)) {
    console.warn("PATCH Request blocked: Missing Authorization header.");
    return null;
  }

  try {
    const response = await apiClient2.patch(url, data, {
      headers: finalHeaders,
      params,
    });
    return response.data;
  } catch (error) {
    console.error('PATCH Request Error:', error);
    throw error;
  }
};

export const put = async (url, data = {}, headers = {}, params = {}) => {
  const finalHeaders = mergeHeaders(headers);

  if (!finalHeaders.Authorization && !isPublicEndpoint(url)) {
    console.warn("PUT Request blocked: Missing Authorization header.");
    return null;
  }

  try {
    const response = await apiClient2.put(url, data, {
      headers: finalHeaders,
      params,
    });
    return response.data;
  } catch (error) {
    console.error('PUT Request Error:', error);
    throw error;
  }
};

export const Delete = async (url, params = {}, headers = {}) => {
  const finalHeaders = mergeHeaders(headers);

  if (!finalHeaders.Authorization && !isPublicEndpoint(url)) {
    console.warn("DELETE Request blocked: Missing Authorization header.");
    return null;
  }

  try {
    console.log("DELETE Request →", { url, params, headers: finalHeaders });

    const response = await apiClient2.delete(url, {
      headers: finalHeaders,
      params,
    });
    return response.data;
  } catch (error) {
    console.error("DELETE Request Error:", error.response || error);
    throw error;
  }
};
